import { BorderRadius, Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const DepositTotalRowWrapper = styled('div')`
  width: 100%;
  padding: ${Spacing.S16};
  border: 1px solid ${Color.Grey100};
  border-radius: ${BorderRadius.R12} ${BorderRadius.R12} 0 0;
  background-color: ${Color.Grey50};
`

export const DepositRemainingRowWrapper = styled('div')`
  width: 100%;
  padding: ${Spacing.S16};
  border: 1px solid ${Color.Grey100};
  border-top: 0;
  border-radius: 0 0 ${BorderRadius.R12} ${BorderRadius.R12};
`
